// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1264px){.chat__group-header[data-v-2ae38360]{display:block!important;text-align:center!important}.chat__back-btn[data-v-2ae38360]{left:10px;margin-left:0!important;position:absolute;top:18px;z-index:2}}.chat__back-btn[data-v-2ae38360]{align-self:center;padding-bottom:2px}.chat__back-btn .v-icon[data-v-2ae38360]{color:#000;margin-left:-8px;margin-right:0;margin-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
